import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-od-orders',
  templateUrl: './od-orders.component.html',
  styleUrls: ['./od-orders.component.css']
})
export class ODOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
